import React from 'react'

const LoadingSpinner = () => {
  return (
    <i className='loading-spinner tw-animate-spin'></i>
  )
}

export default LoadingSpinner
